import React from 'react'
import { FiMail, FiAlertCircle } from 'react-icons/fi'
import { User } from '@/types/auth'

interface EmailVerificationBannerProps {
    user: User
    onVerifyClick: () => void
    className?: string
}

const EmailVerificationBanner: React.FC<EmailVerificationBannerProps> = ({
    user,
    onVerifyClick,
    className = ''
}) => {
    const isEmailVerified = user?.emailVerified

    if (isEmailVerified) {
        return null
    }

    const userEmail = user?.email || ''

    return (
        <div className={`bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4 sm:p-6 ${className}`}>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-start gap-4">
                    <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-amber-100 dark:bg-amber-900/40">
                            <FiAlertCircle className="h-6 w-6 text-amber-600 dark:text-amber-400" />
                        </div>
                    </div>

                    <div className="flex-1">
                        <h3 className="text-base sm:text-lg font-semibold text-amber-900 dark:text-amber-100 mb-1">
                            Verify your email address
                        </h3>
                        <p className="text-sm text-amber-800 dark:text-amber-200 mb-2">
                            We've sent a verification code to <span className="font-medium break-all">{userEmail}</span>. Verify your email to increase your trust score on the platform.
                        </p>
                        <ul className="text-xs text-amber-700 dark:text-amber-300 space-y-1 pl-0">
                            <li className="flex items-center gap-2">
                                <span className="inline-block w-1 h-1 bg-current rounded-full"></span>
                                Get verified badge on your profile
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="inline-block w-1 h-1 bg-current rounded-full"></span>
                                Build trust with employers and workers
                            </li>
                            <li className="flex items-center gap-2">
                                <span className="inline-block w-1 h-1 bg-current rounded-full"></span>
                                Access priority support features
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="flex-shrink-0">
                    <button
                        onClick={onVerifyClick}
                        className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-2.5 bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 dark:focus:ring-offset-gray-900"
                    >
                        <FiMail className="h-4 w-4 mr-2" />
                        Verify now
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EmailVerificationBanner
